import { useEffect, useState } from "react";
import { useSelector,shallowEqual } from "umi";
import dailyFilterDefault from "@/pages/dashboard/filterPageComponents/overview/dailyFilterDefault";
import { getPcV2DailyCountryRegionPlatform } from "@/pages/dashboard/services/overview";
import { PERIODTIMEOBJ } from "@/pages/dashboard/_config/constant";
import { IsSingleDay } from "@/pages/dashboard/utils/utils";

const useData = (
    filterVal: any, 
    filterLoading: boolean, 
    period: string,
    by_type: string,
    metric: string,
    ) => {
  
  const formVal = filterVal || dailyFilterDefault;
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const gameCode = useSelector((state: any) => {
    return state?.dashboard?.currentGame?.game_code
  }, shallowEqual);
  // 点击筛选器的时候
  useEffect(() => {
    if (!filterVal) return;
    if (!filterLoading) {
        getPcDailyCountryRegionPlatformDataFunc()
    }
  }, [formVal, by_type]);

  const getPcDailyCountryRegionPlatformDataFunc = () => {
    const { filterValue } = filterVal;
    const { rangeTime: [start, end], ...filters } =  filterValue;

    const params = {
        game_code: gameCode,
        start_time: start,
        end_time: end,
        period,
        filters: filters,
        by_type,
        metric,
    }

    setLoading(true);
    getPcV2DailyCountryRegionPlatform(params).then((result: any) => {
        setError(false)
        setLoading(false);
        setData({
          chartData: result?.dwm_data_list || [],
          tableData: result?.dwm_list || [],
        });
    }).catch((err: any) => {
        setError(true)
        setLoading(false);
    })
  }

  return {
      // nodata 不在此封装，因为可能是接口的个别项目nodata
      data,
      loading,
      error,
      isSingle: IsSingleDay({ ...filterVal, period: PERIODTIMEOBJ[filterVal?.timeType] }),
      getData:getPcDailyCountryRegionPlatformDataFunc
  }
}

export default useData;